import gsap from "gsap";
import { DURATION, EASE, HERO_DELAY } from "./animation-config.js";

const CONTENT_X = "-100vw";
const DELAY = HERO_DELAY;

const reducedMotion = window.matchMedia(
  "(prefers-reduced-motion: reduce)",
).matches;

function initHero(hero) {
  const content = hero.querySelector(".hero__content");

  if (reducedMotion) {
    if (content) {
      gsap.set(content, { x: 0, opacity: 1 });
    }

    return;
  }

  if (!content) {
    return;
  }

  gsap
    .timeline({
      defaults: { duration: DURATION, ease: EASE },
      delay: DELAY,
    })
    .fromTo(content, { x: CONTENT_X, opacity: 0 }, { x: 0, opacity: 1 }, 0);
}

document.querySelectorAll(".hero").forEach(initHero);
